// 對 localStorage 進行擴展封裝，加入超時的功能
(function () {
  var isIE = /* @cc_on!@ */ false || !!document.documentMode
  if (isIE) return
  const getItem = localStorage.getItem.bind(localStorage)
  const setItem = localStorage.setItem.bind(localStorage)
  const removeItem = localStorage.removeItem.bind(localStorage)
  localStorage.getItem = function (keyName) {
    const expires = getItem(keyName + '_expires')
    if (expires && new Date().getTime() > Number(expires)) {
      removeItem(keyName)
      removeItem(keyName + '_expires')
    }
    return getItem(keyName)
  }
  localStorage.setItem = function (keyName, keyValue, expires) {
    if (typeof expires !== 'undefined') {
      const expiresDate = new Date().getTime() + Number(expires)
      setItem(keyName + '_expires', expiresDate)
    }
    return setItem(keyName, keyValue)
  }
})()



// WEBPACK FOOTER //
// ./src/util/storage.js